import AWS from 'aws-sdk';
import { S3Client, DeleteObjectsCommand } from "@aws-sdk/client-s3"; // Create service client module using ES6 syntax.
import Axios from 'axios';

const bucketRegion = 'ap-northeast-2';
const IdentityPoolId = process.env.REACT_APP_AWS_IDENTITYPOOLID;
export const awsBucketName = 'bucket-hackathon-hub';
AWS.config.region = bucketRegion;
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId,
});

export function getDeletionObjectsForS3(arrS3URLs) {
    if (!arrS3URLs) {
        console.log('arrS3URLs is not valid! :', arrS3URLs);
        return null;
    }

    arrS3URLs = arrS3URLs?.filter(url => url.includes('aws.com/'));

    return arrS3URLs?.map(imgURL => {
        var arrURL = imgURL.split('aws.com/');
        return { Key: arrURL[arrURL.length - 1] };
    });
}

export var s3 = new AWS.S3();

// Create an Amazon S3 service client object.
const s3Client = new S3Client({ region: bucketRegion, credentials: AWS.config.credentials });
export { s3Client };
export const deleteS3Objects = async (bucketParams, successHandler, errorHandler) => {
    try {
        const data = await s3Client.send(new DeleteObjectsCommand(bucketParams));
        successHandler(data);
    } catch (err) {
        errorHandler(err);
    }
};

export const deleteStoredImage = (props, arrStoredURLs) => {
    if (!arrStoredURLs?.length) {
        console.log('arrStoredImages are not valid :', arrStoredURLs);
        return;
    }

    var params = {
        Bucket: awsBucketName,
        Delete: {
            Objects: getDeletionObjectsForS3(arrStoredURLs)
        }
    };

    deleteS3Objects(params, (data) => {
        // successful response
    }, (err) => {
        // an error occurred
        console.log(err, err.stack);
        console.log('S3좀비객체 발생 로그 확인요망!');
        Axios.post('/api/log/add', { user: props?.user?.userData?._id, log: err }).then(resp => {
            if (!resp.data.success) {
                console.log('로그 기록 실패 :', err);
            }
        }).catch(err => {
            console.log('로그 기록 실패 :', err);
        });
    })
    // s3.deleteObjects(params, function (err, data) {
    //   if (err) {
    //     // an error occurred
    //     console.log(err, err.stack);
    //     console.log('S3좀비객체 발생 로그 확인요망!');
    //     Axios.post('/api/log/add', { user: props.user.userData._id, log: err }).then(resp => {
    //       if (!resp.data.success) {
    //         console.log('로그 기록 실패 :', err);
    //       }
    //     }).catch(err => {
    //       console.log('로그 기록 실패 :', err);
    //     });
    //   }
    //   else {
    //     // successful response
    //     console.log('이미지 삭제 완료 :', data);
    //     /*
    //     data = {
    //      Deleted: [
    //         {
    //        DeleteMarker: true,
    //        DeleteMarkerVersionId: "A._w1z6EFiCF5uhtQMDal9JDkID9tQ7F",
    //        Key: "objectkey1"
    //       },
    //      ]
    //     }
    //     */
    //   }
    // });
}

export default AWS;